/* Eigenes Hauptmenue (snippets/cl-menue.liquid), 22.10.2026.
   Computer: Feld oeffnen mit kurzer Verzoegerung, gelber Strich gleitet unter
   den Hauptpunkt, Markenfeld wechselt beim Ueberfahren, Esc schliesst.
   Ohne dieses Skript oeffnen die Felder per CSS (:hover, :focus-within).
   Handy: Reiter Kategorien/Marken/Hilfe und zweite Ebene mit Zurueck. */
(function () {
  'use strict';

  /* Warenkorb-Karte (Drawer des Themes) nach einem Hinzufuegen ausserhalb der
     Theme-Formulare auffrischen. Das Theme laedt den Drawer nur beim ersten
     Oeffnen - war er schon einmal offen, zeigte er danach den alten Inhalt
     ("Dein Warenkorb ist leer"), obwohl die Zahl am Korb stimmte. Eigene
     Kaufknoepfe (Bestseller, Landingpages, Quiz) rufen das nach dem Hinzufuegen
     auf; Seiten, die das Ereignis cart:refresh senden, bekommen es automatisch. */
  window.clKorbAuffrischen = function () {
    if (!window.ajaxCart || !window.fetch) return;
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(wurzel + '?sections=side-cart', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (s) { if (s && s['side-cart']) window.ajaxCart.load({ sections: s }, false); })
      .catch(function () { /* dann bleibt der alte Inhalt bis zum Neuladen */ });
  };
  document.addEventListener('cart:refresh', function () { window.clKorbAuffrischen(); });

  function computer(mm) {
    var punkte = Array.prototype.slice.call(mm.querySelectorAll('[data-cl-punkt]'));
    var strich = mm.querySelector('.cl-mm-strich');
    var karton = mm.querySelector('.cl-mm-karton');
    var offen = null;
    var zeitAuf = null;
    var zeitZu = null;
    var fein = window.matchMedia('(hover: hover) and (pointer: fine)');

    mm.classList.add('ist-bereit');
    mm.addEventListener('cl-mega-zu', function () { zu(); });

    function knopfVon(punkt) { return punkt.querySelector('.cl-mm-knopf'); }

    function strichUnter(el) {
      if (!el || !strich) { mm.classList.remove('hat-strich'); return; }
      var r = el.getBoundingClientRect();
      var rm = mm.getBoundingClientRect();
      strich.style.transform = 'translateX(' + Math.round(r.left - rm.left + r.width / 2 - 24) + 'px)';
      mm.classList.add('hat-strich');
    }

    // Karte auf die Hoehe des offenen Felds bringen. sofort = ohne Gleiten
    // (beim ersten Oeffnen; dann faellt die Karte stattdessen herunter).
    function kartonHoehe(sofort) {
      if (!karton || !offen) return;
      var h = offen.querySelector('.cl-mm-feld').offsetHeight;
      if (sofort) {
        karton.classList.add('ohne-gleiten');
        karton.style.height = h + 'px';
        void karton.offsetHeight;
        karton.classList.remove('ohne-gleiten');
      } else {
        karton.style.height = h + 'px';
      }
    }

    function zu() {
      if (offen) {
        offen.classList.remove('ist-offen');
        knopfVon(offen).setAttribute('aria-expanded', 'false');
      }
      offen = null;
      mm.classList.remove('hat-offen', 'ist-neu');
      strichUnter(null);
    }

    function auf(punkt) {
      if (offen === punkt) return;
      var warOffen = !!offen;
      if (offen) {
        offen.classList.remove('ist-offen');
        knopfVon(offen).setAttribute('aria-expanded', 'false');
      }
      offen = punkt;
      document.dispatchEvent(new CustomEvent('cl-suche-zu'));
      // Feldhoehe auf den Platz unter der Leiste begrenzen (CSS: --cl-mm-oben)
      mm.style.setProperty('--cl-mm-oben', Math.max(0, Math.round(mm.getBoundingClientRect().bottom)) + 'px');
      punkt.classList.add('ist-offen');
      knopfVon(punkt).setAttribute('aria-expanded', 'true');
      mm.classList.add('hat-offen');
      strichUnter(knopfVon(punkt));
      kartonHoehe(!warOffen);
      if (!warOffen) {
        mm.classList.remove('ist-neu');
        void mm.offsetWidth;
        mm.classList.add('ist-neu');
      }
    }

    punkte.forEach(function (punkt) {
      var knopf = knopfVon(punkt);

      punkt.addEventListener('mouseenter', function () {
        if (!fein.matches) return;
        clearTimeout(zeitZu);
        clearTimeout(zeitAuf);
        // Liegt schon ein Feld offen, sofort wechseln; sonst kurz warten,
        // damit ein Ueberstreichen der Leiste nicht gleich alles oeffnet.
        zeitAuf = setTimeout(function () { auf(punkt); }, offen ? 0 : 90);
      });

      knopf.addEventListener('click', function () {
        clearTimeout(zeitAuf);
        if (offen === punkt) { zu(); } else { auf(punkt); }
      });
    });

    // Nicht-Knopf-Punkte (Sale): Strich zeigen, Feld schliessen
    Array.prototype.forEach.call(mm.querySelectorAll('.cl-mm-link'), function (link) {
      link.addEventListener('mouseenter', function () {
        if (!fein.matches) return;
        clearTimeout(zeitAuf);
        zu();
        strichUnter(link);
      });
    });

    mm.addEventListener('mouseleave', function () {
      if (!fein.matches) return;
      clearTimeout(zeitAuf);
      zeitZu = setTimeout(zu, 180);
    });
    mm.addEventListener('mouseenter', function () { clearTimeout(zeitZu); });

    mm.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !offen) return;
      var knopf = knopfVon(offen);
      zu();
      knopf.focus();
    });

    // Fokus verlaesst das Menue (Tab weiter) oder Klick daneben: schliessen
    mm.addEventListener('focusout', function (e) {
      if (offen && e.relatedTarget && !mm.contains(e.relatedTarget)) zu();
    });
    document.addEventListener('click', function (e) {
      if (offen && !mm.contains(e.target)) zu();
    });
    window.addEventListener('resize', function () { if (offen) { strichUnter(knopfVon(offen)); kartonHoehe(true); } });
    // Bilder im Feld laden nach - Hoehe dann nachziehen
    mm.addEventListener('load', function () { kartonHoehe(false); }, true);

    pille(mm, fein, function () { return offen; }, zu);

    // Markenfeld: Detail wechselt beim Ueberfahren oder Fokussieren einer Marke
    Array.prototype.forEach.call(mm.querySelectorAll('.cl-mm-feld-marken'), function (feld) {
      var marken = Array.prototype.slice.call(feld.querySelectorAll('[data-cl-marke]'));
      var details = Array.prototype.slice.call(feld.querySelectorAll('[data-cl-markendetail]'));
      function zeige(nr) {
        marken.forEach(function (m) { m.classList.toggle('ist-aktiv', m.getAttribute('data-cl-marke') === nr); });
        details.forEach(function (d) { d.hidden = d.getAttribute('data-cl-markendetail') !== nr; });
        kartonHoehe(false);
      }
      function ziele(detail) { return Array.prototype.slice.call(detail.querySelectorAll('a[href], button')); }
      marken.forEach(function (m, i) {
        var nr = m.getAttribute('data-cl-marke');
        var detail = feld.querySelector('[data-cl-markendetail="' + nr + '"]');
        m.addEventListener('mouseenter', function () { zeige(nr); });
        m.addEventListener('focus', function () { zeige(nr); });
        if (!detail) return;
        // Tastatur: Tab von der Marke fuehrt in ihr Detail (das im Code erst
        // nach allen Marken steht), Tab am Ende des Details zur naechsten Marke.
        m.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab' || e.shiftKey) return;
          zeige(nr);
          var z = ziele(detail);
          if (z.length) { e.preventDefault(); z[0].focus(); }
        });
        detail.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab') return;
          var z = ziele(detail);
          if (!e.shiftKey && document.activeElement === z[z.length - 1] && marken[i + 1]) {
            e.preventDefault(); marken[i + 1].focus();
          } else if (e.shiftKey && document.activeElement === z[0]) {
            e.preventDefault(); m.focus();
          }
        });
      });
    });
  }

  /* Pille am Computer (CSS: "Pille statt mitlaufender Leiste"). Solange das Theme das
     Menue oben anheftet (#nav.fixed), ist es eine kleine Pille mit Emblem und Burger.
     Ueberfahren, Klick auf den Burger oder Fokus ziehen sie auf die gemessene Breite
     der Hauptpunkte auf; beim Verlassen schrumpft sie kurz danach wieder - etwas
     spaeter als das Feld zugeht (180 ms), damit man ueber die Luecke zum Feld kommt. */
  function pille(mm, fein, offenesFeld, feldZu) {
    var nav = mm.closest('#nav');
    var kreis = mm.querySelector('.cl-mm-kreis');
    var emblem = mm.querySelector('.cl-mm-emblem');
    var leiste = mm.querySelector('.cl-mm-leiste');
    if (!nav || !kreis || !leiste) return;
    var zeitSchmal = null;
    var zeitZurueck = null;
    var warAngeheftet = false;
    function angeheftet() { return nav.classList.contains('fixed') && window.innerWidth > 1000; }

    // Tastaturfokus in der Pille (nicht bloss ein Mausklick)
    function tastaturFokus(el) { return !!el && el.matches(':focus-visible'); }
    // Breite der offenen Pille: bis kurz vor den Korb-Kreis (12 px Luft), die Punkte
    // verteilen sich darin (CSS). Passen sie in natuerlicher Breite nicht hinein - Rand,
    // Emblem, Abstand, Punkte, dazu der Burger, solange er den Tastaturfokus hat (dann
    // bleibt er sichtbar) -, fallen die Symbole weg (ist-eng). Nur angeheftet messbar,
    // vorher steht die Leiste im Theme-Aufbau.
    function messen() {
      if (!angeheftet()) return;
      var max = window.innerWidth - 2 * 18 - 56 - 12;
      var rand = 8 + (emblem ? emblem.offsetWidth : 40) + 8 + 8 + (tastaturFokus(kreis) ? 42 : 0);
      mm.classList.remove('ist-eng');
      // Summe der Punkte statt Breite der Leiste - die ist in der offenen Pille gestreckt
      var punkte = Array.prototype.reduce.call(leiste.children, function (s, li) { return s + li.offsetWidth + 4; }, -4);
      if (rand + punkte > max) mm.classList.add('ist-eng');
      mm.style.setProperty('--cl-pille-offen', max + 'px');
    }
    // Hoehe der vollen Leiste: dort beginnt die Verwandlung zur Pille
    function leisteMerken() {
      if (!nav.classList.contains('fixed') && nav.offsetHeight) mm.style.setProperty('--cl-leiste-hoehe', nav.offsetHeight + 'px');
    }

    function breit(an) {
      clearTimeout(zeitSchmal);
      if (an) messen();
      mm.classList.toggle('ist-breit', an);
      kreis.setAttribute('aria-expanded', an ? 'true' : 'false');
    }
    function schmal() {
      if (offenesFeld()) feldZu();
      breit(false);
    }
    mm.addEventListener('mouseenter', function () {
      if (fein.matches && angeheftet()) breit(true);
    });
    mm.addEventListener('mouseleave', function () {
      if (!fein.matches || !mm.classList.contains('ist-breit')) return;
      clearTimeout(zeitSchmal);
      zeitSchmal = setTimeout(function () {
        // Wird in der Pille gerade per Tastatur bedient, bleibt sie offen
        if (tastaturFokus(mm.querySelector(':focus'))) return;
        schmal();
      }, 260);
    });
    // Burger bekommt oder verliert den Tastaturfokus: Breite neu, siehe messen()
    mm.addEventListener('focusin', function () { if (mm.classList.contains('ist-breit')) messen(); });
    kreis.addEventListener('click', function () {
      if (mm.classList.contains('ist-breit')) schmal(); else breit(true);
    });
    mm.addEventListener('keydown', function (e) {
      // Erst schliesst Esc das Feld (Handler oben), beim naechsten Esc die Pille
      if (e.key !== 'Escape' || offenesFeld() || !mm.classList.contains('ist-breit')) return;
      breit(false);
      kreis.focus();
    });
    mm.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !mm.contains(e.relatedTarget)) breit(false);
    });
    document.addEventListener('click', function (e) {
      if (!mm.contains(e.target) && mm.classList.contains('ist-breit')) schmal();
    });
    window.addEventListener('resize', function () { leisteMerken(); messen(); });

    // Angeheftet: messen. Wieder oben: Pille zu, die Punkte der vollen Leiste kommen sanft zurueck.
    function wechsel() {
      var jetzt = nav.classList.contains('fixed');
      if (jetzt === warAngeheftet) return;
      warAngeheftet = jetzt;
      if (jetzt) {
        // Die Punkte der vollen Leiste sofort weg statt auszublenden - sonst stehen sie
        // kurz im Pillen-Aufbau mitten in der Verwandlung (CSS: .cl-sofort)
        mm.classList.add('cl-sofort');
        setTimeout(function () { mm.classList.remove('cl-sofort'); }, 60);
        messen();
        return;
      }
      schmal();
      clearTimeout(zeitZurueck);
      mm.classList.add('ist-zurueck');
      zeitZurueck = setTimeout(function () { mm.classList.remove('ist-zurueck'); leisteMerken(); }, 500);
    }
    leisteMerken();
    wechsel();
    if (window.MutationObserver) {
      new MutationObserver(wechsel).observe(nav, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* Korb-Kreis: Klick geht an den Korb des Themes (oeffnet die Warenkorb-Karte
     oder fuehrt zum Warenkorb), die Zahl laeuft mit. Das Theme baut den Korb
     beim Aktualisieren teils neu - deshalb wird #cart-count jedes Mal neu gesucht. */
  function korbKreis() {
    var kreis = document.querySelector('[data-cl-korb-kreis]');
    if (!kreis || kreis.dataset.clBereit) return;
    kreis.dataset.clBereit = '1';
    var zahl = kreis.querySelector('[data-cl-korb-zahl]');
    kreis.addEventListener('click', function (e) {
      var echt = document.querySelector('#nav-user li.cart > a');
      if (!echt) return;
      e.preventDefault();
      echt.click();
    });
    var korb = document.querySelector('#nav-user li.cart');
    if (!korb || !zahl || !window.MutationObserver) return;
    function spiegeln() {
      var quelle = document.getElementById('cart-count');
      if (quelle) zahl.textContent = quelle.textContent.trim();
    }
    new MutationObserver(spiegeln).observe(korb, { childList: true, characterData: true, subtree: true });
    spiegeln();
  }

  function handy(mh) {
    var reiter = Array.prototype.slice.call(mh.querySelectorAll('[role="tab"]'));
    var zuKnopf = mh.querySelector('[data-cl-zu]');
    var nav = document.getElementById('nav');
    if (zuKnopf) zuKnopf.addEventListener('click', function () {
      // Erst nach links hinausschieben, dann schliesst das Theme sein Seitenmenue
      var themeZu = document.querySelector('#nav a.close-nav') || document.querySelector('#nav > a.close');
      var schliessen = function () {
        if (themeZu) themeZu.click(); else document.documentElement.classList.remove('m2a');
        // Erst entfernen, wenn das Theme sein Menue ganz zu hat - sonst springt
        // es kurz zurueck ins Bild und blendet danach noch einmal aus (Flackern)
        setTimeout(function () { if (nav) nav.classList.remove('cl-geht'); }, 700);
      };
      if (nav && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        nav.classList.add('cl-geht');
        setTimeout(schliessen, 280);
      } else {
        schliessen();
      }
    });

    var start = mh.querySelector('[data-cl-start]');

    function waehle(tab, fokus) {
      reiter.forEach(function (t) {
        var an = t === tab;
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.tabIndex = an ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !an;
      });
      mh.setAttribute('data-reiter', tab.id.replace('cl-mh-tab-', ''));
      if (fokus) tab.focus();
    }

    reiter.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        // Zurueck zum Anfang der Kategorien, wenn man den Reiter wechselt
        if (tab.getAttribute('aria-selected') !== 'true') zeigeStart(null);
        waehle(tab, false);
      });
      tab.addEventListener('keydown', function (e) {
        var schritt = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!schritt) return;
        e.preventDefault();
        waehle(reiter[(i + schritt + reiter.length) % reiter.length], true);
      });
    });

    function zeigeStart(zurueckZu) {
      Array.prototype.forEach.call(mh.querySelectorAll('[data-cl-ebene-ziel]'), function (e) { e.hidden = true; });
      if (start) start.hidden = false;
      if (zurueckZu) zurueckZu.focus();
    }

    Array.prototype.forEach.call(mh.querySelectorAll('[data-cl-ebene]'), function (kachel) {
      kachel.addEventListener('click', function () {
        var ziel = mh.querySelector('[data-cl-ebene-ziel="' + kachel.getAttribute('data-cl-ebene') + '"]');
        if (!ziel) return;
        if (start) start.hidden = true;
        ziel.hidden = false;
        var zurueck = ziel.querySelector('[data-cl-zurueck]');
        zurueck.onclick = function () { zeigeStart(kachel); };
        zurueck.focus();
      });
    });
  }

  // Das Theme fokussiert beim Oeffnen des Seitenmenues den ersten Link im
  // #nav - der liegt jetzt im verborgenen Computer-Menue. Deshalb den
  // gewaehlten Reiter fokussieren, sobald das Seitenmenue offen ist (html.m2a).
  function fokusBeimOeffnen(mh) {
    var war = false;
    new MutationObserver(function () {
      var auf = document.documentElement.classList.contains('m2a');
      // Schnell wieder geoeffnet, waehrend das Hinausschieben noch nachwirkt
      if (auf && !war) { var n = document.getElementById('nav'); if (n) n.classList.remove('cl-geht'); }
      if (auf && !war && window.matchMedia('(max-width: 1000px)').matches) {
        setTimeout(function () {
          var tab = mh.querySelector('[role="tab"][aria-selected="true"]');
          if (tab) tab.focus({ preventScroll: true });
        }, 80);
      }
      war = auf;
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  // Lupe im Handy-Kopf: oeffnet das Seitenmenue und setzt den Fokus ins Suchfeld.
  // Nur einmal angemeldet; das aktuelle Menue wird beim Klick gesucht (der
  // Theme-Editor rendert den Header neu).
  var lupeAktiv = false;
  function lupe() {
    if (lupeAktiv) return;
    lupeAktiv = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#header a.search-compact');
      if (!a || !window.matchMedia('(max-width: 1000px)').matches) return;
      var knopf = document.querySelector('#header a[aria-controls="nav"]');
      if (!knopf) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      knopf.click();
      setTimeout(function () {
        var feld = document.querySelector('[data-cl-handy] .cl-mh-suche input[type="search"]');
        if (feld) feld.focus();
      }, 420);
    }, true);
  }

  // Sprache und Land: ein Fenster fuer Handy (von unten) und Computer (Karte
  // von rechts). Geoeffnet von jeder Schaltflaeche mit data-cl-fenster-auf;
  // Schliessen (X, Rand, Esc) gleitet erst hinaus. Einmal angemeldet,
  // das Fenster wird beim Klick gesucht (der Theme-Editor rendert neu).
  var fensterAktiv = false;
  function fensterEinrichten() {
    if (fensterAktiv) return;
    fensterAktiv = true;
    // Das Fenster wandert beim ersten Oeffnen an <body> (WebKit zeichnet den Dialog im
    // verschobenen Seitenmenue sonst nicht). Rendert der Theme-Editor den Kopf neu, gilt
    // das frische Fenster im Kopf, das alte am <body> wird entfernt.
    function dlg() {
      var imKopf = document.querySelector('#nav .cl-fenster');
      var amBody = document.querySelector('body > .cl-fenster');
      if (imKopf && amBody) { amBody.remove(); amBody = null; }
      return imKopf || amBody;
    }
    function auf(f) {
      if (f.parentNode !== document.body) document.body.appendChild(f);
      f.classList.remove('ist-zu');
      if (typeof f.showModal === 'function') { if (!f.open) f.showModal(); } else f.setAttribute('open', '');
    }
    function zu(f) {
      if (!f.open || f.classList.contains('ist-zu')) return;
      var weg = function () {
        f.classList.remove('ist-zu');
        if (typeof f.close === 'function') f.close(); else f.removeAttribute('open');
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { weg(); return; }
      f.classList.add('ist-zu');
      setTimeout(weg, 280);
    }
    document.addEventListener('click', function (e) {
      var f = dlg();
      if (!f || !e.target.closest) return;
      if (e.target.closest('[data-cl-fenster-auf]')) { e.preventDefault(); auf(f); return; }
      if (!f.open) return;
      if (e.target.closest('[data-cl-fenster-zu]') || e.target === f) { zu(f); return; }
      // type=button + submit(): ein Theme-Handler (Zusatzprodukte) faengt sonst Absende-Knoepfe ab
      var ok = e.target.closest('[data-cl-fenster-ok]');
      if (ok) ok.closest('form').submit();
    });
    // Esc: nur das Fenster schliessen (gleitend), nicht auch das Seitenmenue des Themes
    document.addEventListener('keydown', function (e) {
      var f = dlg();
      if (!f || !f.open || e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
      zu(f);
    }, true);
  }

  /* ===================== Suche =====================
     Computer: Feld im Theme-Kopf (#search_main), Ergebnisse unter der
     Menueleiste (.cl-suche-feld). Handy: Feld im Seitenmenue, Ergebnisse
     darunter (.cl-mh-sucheraum). Treffer live aus Shopifys Predictive
     Search; Kategorien, Marken, leerer Zustand und Texte aus
     #cl-suche-daten (snippets/cl-suche-daten.liquid). Enter sendet wie
     gewohnt an die Suchseite. */
  var suchDaten = null, suchDatenEl = null;
  function daten() {
    var el = document.getElementById('cl-suche-daten');
    // Rendert der Theme-Editor den Header neu, gibt es ein neues Datenelement - dann neu einlesen
    if (suchDaten && el === suchDatenEl) return suchDaten;
    suchDaten = null;
    begriffListe = null;
    if (!el) return null;
    suchDatenEl = el;
    try {
      suchDaten = JSON.parse(el.textContent);
      suchDaten.kategorien = (suchDaten.kategorien || []).filter(Boolean);
      // Shopifys Filter t maskiert Sonderzeichen (Nature&#39;s) - hier zurueck in Klartext,
      // esc() maskiert beim Anzeigen ohnehin selbst
      var klar = function (s) {
        if (typeof s !== 'string' || s.indexOf('&') < 0) return s;
        var ta = document.createElement('textarea');
        ta.innerHTML = s;
        return ta.value;
      };
      Object.keys(suchDaten.texte || {}).forEach(function (k) {
        var w = suchDaten.texte[k];
        suchDaten.texte[k] = Array.isArray(w) ? w.map(klar) : klar(w);
      });
      suchDaten.beliebt = (suchDaten.beliebt || []).map(klar);
    } catch (e) { return null; }
    return suchDaten;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function preis(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return esc(p);
    var w = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: w }).format(n); }
    catch (e) { return n.toFixed(2); }
  }
  function bild(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function text(k, q) { var d = daten(); return (d.texte[k] || '').replace('{q}', q || ''); }
  function suchUrl(q) { return daten().suche + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  // Zuletzt gesucht: nur im Browser des Kunden (Komfort), darf fehlen
  function zuletzt() { try { return JSON.parse(localStorage.getItem('cl-suche-zuletzt') || '[]').slice(0, 5); } catch (e) { return []; } }
  function merken(q) {
    q = (q || '').trim();
    if (!q) return;
    try {
      var l = zuletzt().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      l.unshift(q);
      localStorage.setItem('cl-suche-zuletzt', JSON.stringify(l.slice(0, 5)));
    } catch (e) { /* ohne Speicher geht es auch */ }
  }
  // Getippter Teil normal, Ergaenzung fett (wie im Mockup)
  function fett(t, q) {
    var i = t.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0 || !q) return '<strong>' + esc(t) + '</strong>';
    return '<strong>' + esc(t.slice(0, i)) + '</strong>' + esc(t.slice(i, i + q.length)) + '<strong>' + esc(t.slice(i + q.length)) + '</strong>';
  }
  /* Tippfehler: Begriffe aus Marken, Herstellern, Kategorien und beliebten
     Suchen mit dem Getippten vergleichen (Woerter einzeln, Vertauschen zaehlt
     als ein Fehler, das letzte Wort darf noch unfertig sein). Bis 3 Zeichen
     kein Fehler erlaubt, bis 5 einer, darueber zwei. */
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss').replace(/['’`´]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function abstand(a, b) {
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 1; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      for (j = 1; j <= b.length; j++) {
        var k = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + k);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[a.length][b.length];
  }
  // Das letzte Wort darf unfertig sein (Vergleich mit dem Wortanfang). Ein
  // abgebrochenes Wort weiter vorn zaehlt als ein Fehler - so bekommt
  // "natur protection" den Hinweis, "natures protec" aber nicht.
  function wortAbstand(w, t, unfertig) {
    var best = abstand(w, t), anfang = 99;
    for (var n = Math.max(1, w.length - 1); n <= Math.min(t.length - 1, w.length + 1); n++) anfang = Math.min(anfang, abstand(w, t.slice(0, n)));
    return Math.min(best, unfertig ? anfang : anfang + 1);
  }
  function naehe(q, begriff) {
    var qw = norm(q).split(' ').filter(Boolean), bw = norm(begriff).split(' ').filter(Boolean), summe = 0;
    if (!qw.length || !bw.length) return null;
    for (var i = 0; i < qw.length; i++) {
      var w = qw[i], best = 99;
      for (var j = 0; j < bw.length && best > 0; j++) best = Math.min(best, wortAbstand(w, bw[j], i === qw.length - 1));
      if (best > (w.length < 4 ? 0 : w.length < 6 ? 1 : 2)) return null;
      summe += best;
    }
    return summe;
  }
  var begriffListe = null;
  function begriffe() {
    if (begriffListe) return begriffListe;
    var d = daten(), gesehen = {};
    begriffListe = [].concat(
      d.marken.map(function (m) { return m.t; }), d.anbieter || [],
      d.kategorien.map(function (k) { return k.t; }), d.beliebt, d.schnell.map(function (c) { return c.t; })
    ).filter(function (b) { var n = norm(b); if (!n || gesehen[n]) return false; gesehen[n] = 1; return true; });
    return begriffListe;
  }
  // Liefert den gemeinten Begriff - oder null, wenn das Getippte schon passt
  function korrektur(q) {
    if (norm(q).length < 4) return null;
    var liste = begriffe(), best = null, wert = 99;
    for (var i = 0; i < liste.length; i++) {
      var m = naehe(q, liste[i]);
      if (m === 0) return null;
      if (m !== null && m < wert) { best = liste[i]; wert = m; }
    }
    return best;
  }
  function passtUngefaehr(t, q) { return passt(t, q) || (norm(q).length >= 4 && naehe(q, t) !== null); }
  function passt(t, q) {
    var s = t.toLowerCase();
    return q.toLowerCase().split(/\s+/).filter(Boolean).every(function (w) { return s.indexOf(w) > -1; });
  }
  var korbIc = '<svg class="cl-ic cl-s-korb-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var ladeIc = '<svg class="cl-ic cl-s-lade" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 1-9 9"/></svg>';
  var hakenIc = '<svg class="cl-ic cl-s-haken" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  // Produktkarte: Bild, Marke, Titel (mit "mehr anzeigen", falls gekuerzt), Preis und Warenkorb-Knopf
  function karte(p, handy) {
    var b = p.b ? '<img src="' + esc(bild(p.b, handy ? 160 : 400)) + '" alt="" loading="lazy">' : '';
    return '<div class="cl-s-produkt">' +
      '<a class="cl-s-produkt-bild" href="' + esc(p.u) + '" data-cl-s-merken tabindex="-1" aria-hidden="true">' + b + '</a>' +
      '<div class="cl-s-produkt-text">' + (p.v ? '<small>' + esc(p.v) + '</small>' : '') +
      '<a class="cl-s-produkt-titel" href="' + esc(p.u) + '" data-cl-s-merken>' + esc(p.t) + '</a>' +
      '<button type="button" class="cl-s-mehr" data-cl-s-mehr aria-expanded="false" hidden>' + esc(text('mehr')) + '</button></div>' +
      '<div class="cl-s-produkt-fuss"><span class="cl-s-produkt-preis">' + p.preis + '</span>' +
      (p.h && p.a !== false ? '<button type="button" class="cl-s-korb" data-cl-s-korb="' + esc(p.h) + '" data-cl-s-url="' + esc(p.u) + '" aria-label="' + esc(text('korb')) + '">' + korbIc + ladeIc + hakenIc + '</button>' : '') +
      '</div></div>';
  }
  // "mehr anzeigen" nur bei Titeln, die wirklich gekuerzt sind
  function mehrPruefen(raum) {
    Array.prototype.forEach.call(raum.querySelectorAll('.cl-s-produkt-titel'), function (t) {
      var m = t.parentNode.querySelector('[data-cl-s-mehr]');
      if (m && !t.closest('.cl-s-produkt').classList.contains('offen')) m.hidden = t.scrollHeight <= t.clientHeight + 1;
    });
  }
  function mehrUmschalten(m) {
    var k = m.closest('.cl-s-produkt'), offen = !k.classList.contains('offen');
    k.classList.toggle('offen', offen);
    m.setAttribute('aria-expanded', offen ? 'true' : 'false');
    m.textContent = text(offen ? 'weniger' : 'mehr');
  }
  /* Warenkorb: Produkte mit nur einer Variante kommen direkt hinein (wie in den
     Bestseller-Reihen); mit Auswahl (Groesse, Farbe) oder bei Fehlern geht es
     zur Produktseite. Danach kurz ein Haken und die Zahl am Korb im Kopf. */
  function inDenKorb(knopf) {
    // Sperre ueber aria-busy statt disabled: das Theme faerbt deaktivierte Knoepfe gelb, der gruene Haken waere weg
    if (knopf.getAttribute('aria-busy') === 'true') return;
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ziel = knopf.getAttribute('data-cl-s-url');
    knopf.setAttribute('aria-busy', 'true');
    knopf.classList.add('laedt');
    function fertig(ok) {
      knopf.classList.remove('laedt');
      if (!ok) { knopf.removeAttribute('aria-busy'); return; }
      knopf.classList.add('fertig');
      knopf.setAttribute('aria-label', text('imKorb'));
      setTimeout(function () { knopf.classList.remove('fertig'); knopf.removeAttribute('aria-busy'); knopf.setAttribute('aria-label', text('korb')); }, 2200);
    }
    fetch(wurzel + 'products/' + encodeURIComponent(knopf.getAttribute('data-cl-s-korb')) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (p) {
        var frei = (p.variants || []).filter(function (v) { return v.available; });
        if ((p.variants || []).length !== 1 || !frei.length) { fertig(false); window.location.href = ziel; return; }
        return fetch(wurzel + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          // sections: den Warenkorb-Drawer gleich mitliefern lassen, damit das Theme ihn auffrischt
          body: JSON.stringify({ items: [{ id: frei[0].id, quantity: 1 }], sections: 'side-cart', sections_url: window.location.pathname })
        }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); }).then(function (antwort) {
          // Hinzugefuegt - ab hier nicht mehr zur Produktseite springen, auch wenn das Auffrischen scheitert
          fertig(true);
          if (window.general && window.general.template === 'cart') { window.location.reload(); return; }
          try {
            // Theme-Logik (custom-async.js): Drawer-Inhalt und Zahl am Korb neu, Drawer bleibt zu
            if (window.ajaxCart && antwort.sections && antwort.sections['side-cart']) { window.ajaxCart.load(antwort, false); return; }
          } catch (e) { /* dann wenigstens die Zahl */ }
          fetch(wurzel + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (k) {
              var z = document.getElementById('cart-count');
              if (z && typeof k.item_count !== 'undefined') z.textContent = k.item_count;
            })
            .catch(function () {});
        });
      })
      .catch(function () { fertig(false); window.location.href = ziel; });
  }
  function chip(t, extra) { return '<button type="button" class="cl-s-chip" data-cl-s-begriff="' + esc(t) + '">' + (extra || '') + esc(t) + '</button>'; }
  var uhr = '<svg class="cl-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  var lupeIc = '<svg class="cl-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>';
  var fuellIc = '<svg class="cl-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 17 7 7M7 15V7h8"/></svg>';
  var pfeilIc = '<svg class="cl-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function leerHtml(handy) {
    var d = daten(), z = zuletzt(), h = '';
    var links = '';
    if (z.length) links += '<div class="cl-s-gruppe"><p class="cl-s-ueber">' + esc(text('zuletzt')) + '</p><div class="cl-s-chips">' + z.map(function (x) { return chip(x, uhr); }).join('') + '</div></div>';
    if (d.beliebt.length) links += '<div class="cl-s-gruppe"><p class="cl-s-ueber">' + esc(text('beliebt')) + '</p>' + d.beliebt.map(function (x, i) {
      return '<button type="button" class="cl-s-zeile" data-cl-s-begriff="' + esc(x) + '"><span class="cl-s-nr">' + (i + 1) + '</span>' + esc(x) + '</button>';
    }).join('') + '</div>';
    var rechts = '';
    if (d.schnell.length) rechts += '<div class="cl-s-gruppe"><p class="cl-s-ueber">' + esc(text('schnell')) + '</p><div class="cl-s-kacheln">' + d.schnell.slice(0, 4).map(function (c) {
      return '<a class="cl-s-kachel" href="' + esc(c.u) + '">' + esc(c.t) + pfeilIc + '</a>';
    }).join('') + '</div></div>';
    if (d.produkte.length) rechts += '<div class="cl-s-gruppe"><p class="cl-s-ueber">' + esc(text('gerade')) + '</p><div class="cl-s-produkte cl-s-produkte-leer">' + d.produkte.map(function (p) { return karte(p, handy); }).join('') + '</div></div>';
    h = '<div class="cl-s-raster"><div class="cl-s-links">' + links + '</div><div class="cl-s-rechts">' + rechts + '</div></div>';
    return h;
  }

  // Hinweis ueber den Treffern: "Meintest du ...?" oder "Treffer fuer ... statt ..."
  function hinweisHtml(info) {
    if (!info) return '';
    var k = '<button type="button" class="cl-s-hinweis-begriff" data-cl-s-begriff="' + esc(info.k) + '">' + esc(info.k) + '</button>';
    var vorlage = info.statt ? (daten().texte.statt || '').replace('{q}', info.statt) : text('meintest');
    return '<p class="cl-s-hinweis">' + vorlage.split('{k}').map(esc).join(k) + '</p>';
  }

  function trefferHtml(q, ergebnis, handy, info) {
    var d = daten();
    var vorschlaege = (ergebnis.queries || []).map(function (x) { return x.text; }).filter(function (t) { return t && t.toLowerCase() !== q.toLowerCase(); }).slice(0, 5);
    var produkte = (ergebnis.products || []).slice(0, 4).map(function (p) {
      return { t: p.title, v: p.vendor, u: p.url, h: p.handle, a: p.available, preis: preis(p.price), b: (p.featured_image && p.featured_image.url) || p.image || null };
    });
    var kat = d.kategorien.filter(function (k) { return passtUngefaehr(k.t, q); }).slice(0, 3);
    var anbieter = (ergebnis.products || []).map(function (p) { return (p.vendor || '').toLowerCase(); });
    var marken = d.marken.filter(function (m) {
      var n = m.t.toLowerCase();
      return passtUngefaehr(m.t, q) || anbieter.some(function (a) { return a && (a.indexOf(n) > -1 || n.indexOf(a) > -1); });
    }).slice(0, handy ? 3 : 2);

    if (!vorschlaege.length && !produkte.length && !kat.length && !marken.length) {
      var hilfe = zuletzt().concat(d.beliebt).slice(0, 4);
      return hinweisHtml(info) + '<div class="cl-s-keine"><div class="cl-s-keine-text"><p class="cl-s-keine-titel">' + esc(text('keine', q)) + '</p>' +
        '<p>' + esc(text('keineText')) + '</p><div class="cl-s-chips">' + hilfe.map(function (x) { return chip(x); }).join('') + '</div></div>' +
        '<a class="cl-s-beratung" href="' + esc(d.whatsapp) + '" target="_blank" rel="noopener"><small>' + esc(text('beratungVor')) + '</small>' +
        '<strong>' + esc(text('beratungTitel')) + '</strong><span>' + esc(text('beratungText')) + '</span></a></div>';
    }
    var links = '';
    if (vorschlaege.length) links += '<div class="cl-s-gruppe"><p class="cl-s-ueber">' + esc(text('vorschlaege')) + '</p>' + vorschlaege.map(function (t) {
      return '<div class="cl-s-vorschlag"><button type="button" class="cl-s-zeile" data-cl-s-begriff="' + esc(t) + '">' + lupeIc + '<span>' + fett(t, q) + '</span></button>' +
        (handy ? '<button type="button" class="cl-s-fuellen" data-cl-s-fuellen="' + esc(t) + '" aria-label="' + esc(text('uebernehmen')) + '">' + fuellIc + '</button>' : '') + '</div>';
    }).join('') + '</div>';
    if (kat.length || (handy && marken.length)) {
      links += '<div class="cl-s-gruppe"><p class="cl-s-ueber">' + esc(handy ? text('kategorien') + ' · ' + text('marken') : text('kategorien')) + '</p><div class="cl-s-kategorien">' +
        kat.map(function (k) { return '<a class="cl-s-kategorie" href="' + esc(k.u) + '" data-cl-s-merken><small>' + esc(k.p) + ' ›</small><span>' + esc(k.t) + '</span></a>'; }).join('') +
        (handy ? marken.map(function (m) { return '<a class="cl-s-kategorie cl-s-marke-chip" href="' + esc(m.u) + '" data-cl-s-merken>' + (m.b ? '<img src="' + esc(m.b) + '" alt="">' : '') + '<span><small>' + esc(text('marken')) + '</small>' + esc(m.t) + '</span></a>'; }).join('') : '') +
        '</div></div>';
    }
    if (!handy && marken.length) links += '<div class="cl-s-gruppe"><p class="cl-s-ueber">' + esc(text('marken')) + '</p>' + marken.map(function (m) {
      return '<a class="cl-s-marke" href="' + esc(m.u) + '" data-cl-s-merken><span class="cl-s-marke-bild">' + (m.b ? '<img src="' + esc(m.b) + '" alt="">' : '') + '</span><span class="cl-s-marke-name">' + esc(m.t) + '</span><small>' + esc(text('markenwelt')) + '</small></a>';
    }).join('') + '</div>';
    var rechts = '';
    if (produkte.length) rechts = '<div class="cl-s-kopf"><p class="cl-s-ueber">' + esc(text('produkte')) + '</p>' +
      (handy ? '' : '<a class="cl-s-alle" href="' + esc(suchUrl(q)) + '" data-cl-s-merken>' + esc(text('alle', q)) + pfeilIc + '</a>') + '</div>' +
      '<div class="cl-s-produkte">' + produkte.map(function (p) { return karte(p, handy); }).join('') + '</div>';
    var h = hinweisHtml(info) + '<div class="cl-s-raster"><div class="cl-s-links">' + links + '</div><div class="cl-s-rechts">' + rechts + '</div></div>';
    if (handy) h += '<a class="cl-s-alle-knopf" href="' + esc(suchUrl(q)) + '" data-cl-s-merken>' + esc(text('alle', q)) + pfeilIc + '</a>';
    else h += '<p class="cl-s-tasten">' + esc(text('tasten')) + '</p>';
    return h;
  }

  // Verbindet ein Suchfeld mit seinem Ergebnisbereich
  function sucheVerbinden(feld, raum, handy, sichtbar) {
    if (!feld || !raum || feld.dataset.clSuche) return;
    feld.dataset.clSuche = '1';
    var abbruch = null, zeit = null, letzte = null, ruhig = false, ersatz = null;
    function zeigen(html) { raum.innerHTML = html; sichtbar(true); mehrPruefen(raum); }
    // Schliessen verwirft auch laufende Anfragen - eine spaete Antwort darf
    // die Suche (oder ein inzwischen offenes Mega-Menue) nicht wieder aendern
    function schliessen() {
      clearTimeout(zeit);
      if (abbruch) abbruch.abort();
      abbruch = null;
      letzte = null;
      sichtbar(false);
    }
    function laden() {
      var q = feld.value.trim();
      if (!daten()) return;
      if (!q) { if (abbruch) abbruch.abort(); letzte = ''; zeigen(leerHtml(handy)); return; }
      if (q === letzte) return;
      letzte = q;
      if (abbruch) abbruch.abort();
      abbruch = window.AbortController ? new AbortController() : null;
      var url = function (begriff) { return daten().predictive + '.json?q=' + encodeURIComponent(begriff) +
        '&resources%5Btype%5D=product,query&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last'; };
      var dieser = abbruch;
      function holen(begriff) {
        return fetch(url(begriff), dieser ? { signal: dieser.signal } : {})
          // Fehler (z. B. 429) nicht als "nichts gefunden" werten - sonst wuerde die Suche umgeschrieben
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (j) { if (!j.resources) throw new Error('ohne Treffer-Liste'); return j.resources.results || {}; });
      }
      function aktuell() { return abbruch === dieser && letzte === q && feld.value.trim() === q; }
      var k = korrektur(q);
      ersatz = null;
      holen(q)
        .then(function (erg) {
          if (!aktuell()) return;
          var leer = !(erg.products || []).length && !(erg.queries || []).length;
          if (!leer || !k) { zeigen(trefferHtml(q, erg, handy, k ? { k: k } : null)); return; }
          // Nichts gefunden, aber ein naher Begriff: gleich dessen Treffer zeigen
          return holen(k).then(function (erg2) {
            if (!aktuell()) return;
            ersatz = { von: q, nach: k };
            zeigen(trefferHtml(k, erg2, handy, { k: k, statt: q }));
          });
        })
        .catch(function () { /* abgebrochen oder offline: alte Anzeige bleibt */ });
    }
    feld.addEventListener('focus', function () { if (!ruhig) laden(); });
    feld.addEventListener('input', function () { clearTimeout(zeit); zeit = setTimeout(laden, 160); });
    if (feld.form) feld.form.addEventListener('submit', function () {
      if (ersatz && feld.value.trim() === ersatz.von) feld.value = ersatz.nach;
      merken(feld.value);
    });
    raum.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cl-s-begriff]');
      var f = e.target.closest('[data-cl-s-fuellen]');
      var m = e.target.closest('[data-cl-s-mehr]');
      var korb = e.target.closest('[data-cl-s-korb]');
      if (m) { e.preventDefault(); mehrUmschalten(m); return; }
      if (korb) { e.preventDefault(); inDenKorb(korb); return; }
      if (b || f) {
        e.preventDefault();
        feld.value = (b ? b.getAttribute('data-cl-s-begriff') : f.getAttribute('data-cl-s-fuellen') + ' ');
        feld.focus();
        laden();
        return;
      }
      if (e.target.closest('[data-cl-s-merken]')) merken(feld.value);
    });
    // Pfeiltasten: vom Feld in die Ergebnisse und zwischen ihnen
    function ziele() { return Array.prototype.slice.call(raum.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([hidden])')); }
    feld.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { var z = ziele(); if (z.length) { e.preventDefault(); z[0].focus(); } }
    });
    raum.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var z = ziele(), i = z.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowUp' && i === 0) { feld.focus(); return; }
      z[Math.max(0, Math.min(z.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)))].focus();
    });
    return {
      schliessen: schliessen,
      // Fokus zurueck ins Feld, ohne die Suche gleich wieder zu oeffnen (Esc)
      fokus: function () { ruhig = true; feld.focus(); ruhig = false; }
    };
  }

  /* Tipp-Animation im leeren Suchfeld: beliebte Suchen werden Zeichen fuer
     Zeichen geschrieben und wieder geloescht. Steht der Kunde im Feld oder hat
     etwas getippt, gilt der normale Platzhalter. Ohne Bewegung (reduced
     motion) bleibt es beim Platzhalter. */
  function tippen(feld) {
    var d = daten();
    var saetze = d && (d.texte.tipp || []).filter(function (s) { return s && s.trim(); });
    if (!feld || feld.dataset.clTippt || !saetze || !saetze.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    feld.dataset.clTippt = '1';
    var ruhe = feld.getAttribute('placeholder') || '', i = 0, n = 0, weg = false;
    function schritt() {
      if (!feld.isConnected) return;
      if (document.activeElement === feld || feld.value || document.hidden) {
        feld.setAttribute('placeholder', ruhe);
        n = 0; weg = false;
        setTimeout(schritt, 1000);
        return;
      }
      var s = saetze[i].trim(), warte = 65 + Math.random() * 50;
      if (!weg) {
        n++;
        if (n >= s.length) { weg = true; warte = 1900; }
      } else {
        n--;
        warte = 28;
        if (n <= 0) { weg = false; i = (i + 1) % saetze.length; warte = 450; }
      }
      feld.setAttribute('placeholder', s.slice(0, n) + '|');
      setTimeout(schritt, warte);
    }
    setTimeout(schritt, 1200);
  }

  function sucheComputer(mm) {
    var form = document.getElementById('search');
    var feld = document.getElementById('search_main');
    var raum = mm.querySelector('[data-cl-suche-feld]');
    if (!form || !feld || !raum || raum.dataset.clBereit) return;
    raum.dataset.clBereit = '1';
    // Das Theme holt mit dieser Klasse keine eigenen Treffer mehr
    form.classList.add('no-autocomplete');
    function sichtbar(an) {
      if (an && !window.matchMedia('(min-width: 1001px)').matches) return;
      raum.hidden = !an;
      mm.classList.toggle('sucht', an);
      if (an) {
        mm.dispatchEvent(new CustomEvent('cl-mega-zu'));
        lage();
      }
    }
    // Karte haengt knapp unter dem Suchfeld und liegt ueber der Menueleiste
    function lage() {
      var f = feld.getBoundingClientRect(), m = mm.getBoundingClientRect();
      mm.style.setProperty('--cl-s-oben', Math.round(f.bottom - m.top + 10) + 'px');
      mm.style.setProperty('--cl-s-max', Math.max(240, Math.round(window.innerHeight - f.bottom - 26)) + 'px');
    }
    var lageWartet = false;
    function lageSpaeter() {
      if (raum.hidden || lageWartet) return;
      lageWartet = true;
      requestAnimationFrame(function () { lageWartet = false; lage(); });
    }
    window.addEventListener('scroll', lageSpaeter, { passive: true });
    window.addEventListener('resize', lageSpaeter);
    var suche = sucheVerbinden(feld, raum, false, sichtbar);
    document.addEventListener('cl-suche-zu', function () { suche.schliessen(); });
    document.addEventListener('click', function (e) {
      if (raum.hidden) return;
      if (raum.contains(e.target) || form.contains(e.target)) return;
      suche.schliessen();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || raum.hidden) return;
      if (!raum.contains(document.activeElement) && document.activeElement !== feld) return;
      suche.schliessen();
      suche.fokus();
    });
  }

  function sucheHandy(mh) {
    var form = mh.querySelector('.cl-mh-suche');
    var feld = form && form.querySelector('input[type="search"]');
    var raum = mh.querySelector('[data-cl-suche-handy]');
    var weg = form && form.querySelector('[data-cl-s-weg]');
    if (!feld || !raum || raum.dataset.clBereit) return;
    raum.dataset.clBereit = '1';
    function sichtbar(an) {
      raum.hidden = !an;
      mh.classList.toggle('sucht', an);
      if (weg) weg.hidden = !an;
    }
    var suche = sucheVerbinden(feld, raum, true, sichtbar);
    if (weg) weg.addEventListener('click', function () { feld.value = ''; suche.schliessen(); feld.blur(); });
  }

  function los() {
    var mm = document.querySelector('[data-cl-menue]');
    var mh = document.querySelector('[data-cl-handy]');
    fensterEinrichten();
    if (mm && !mm.classList.contains('ist-bereit')) computer(mm);
    korbKreis();
    if (mm) sucheComputer(mm);
    if (mh) sucheHandy(mh);
    tippen(document.getElementById('search_main'));
    if (mh) tippen(mh.querySelector('.cl-mh-suche input[type="search"]'));
    if (mh && !mh.hasAttribute('data-reiter')) { mh.setAttribute('data-reiter', 'kat'); handy(mh); fokusBeimOeffnen(mh); lupe(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los);
  else los();
  // Theme-Editor rendert den Header neu
  document.addEventListener('shopify:section:load', los);
})();
